import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-support",
  "use": "icon-support-usage",
  "viewBox": "0 0 12 12",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 12\" id=\"icon-support\"><defs><style>#icon-support .cls-1{fill:#52c41a;}</style></defs><g id=\"icon-support_图层_2\" data-name=\"图层 2\"><g id=\"icon-support_File_Types\" data-name=\"File Types\"><path id=\"icon-support_support\" class=\"cls-1\" d=\"M6,0a6,6,0,1,0,6,6A6,6,0,0,0,6,0ZM5.08,8.44,2.57,6l.66-.64,1.85,1.8,3.69-3.6.66.64Z\" /></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol